class IntLocalFormat extends HTMLInputElement {
  static get THOUSAND_SEPARATOR () {
    return new Intl.NumberFormat(navigator.language).format(999999).replace(/9/g, '')
  }

  connectedCallback () {
    // Deliberadamente NO asignamos `pattern`. Un atributo `pattern` de dígitos sobre un
    // <input type="text"> con `inputmode="numeric"` es la firma exacta que Safari/WebKit y
    // la extensión iCloud Passwords usan para clasificar el campo como código de verificación
    // (OTP): hacen aparecer el popup del gestor de contraseñas encima de los campos de importe.
    // No es nada evidente —costó aislarlo probando variante a variante en producción— así que
    // ojo con reintroducirlo. `autocomplete="off"` NO lo evita (Apple lo ignora); quitar el
    // `pattern` sí. La validación de número, min y max la cubre el listener de `input` con
    // setCustomValidity, y el formato queda garantizado al reformatear el valor en cada
    // pulsación. Diagnóstico y verificación en producción: ENH-RNK-2854.
    this.addEventListener('input', () => {
      if (this.value !== '') {
        const valor = this.valueAsNumber
        const max = this.hasAttribute('max') ? parseInt(this.getAttribute('max')) : valor
        const min = this.hasAttribute('min') ? parseInt(this.getAttribute('min')) : valor

        if (isNaN(valor)) {
          this.setCustomValidity('Debe ser un número')
        } else if (valor > max) {
          this.setCustomValidity(`El valor debe ser inferior o igual a ${this._numberToLocalString(max)}`)
        } else if (valor < min) {
          this.setCustomValidity(`El valor debe ser superior o igual a ${this._numberToLocalString(min)}`)
        } else {
          this.setCustomValidity('')
        }

        this.value = isNaN(valor) ? '' : this._numberToLocalString(valor)
      }
    })
  }

  get valueAsNumber () {
    return Number(this.originalValue())
  }

  originalValue () {
    return this.value.replace(new RegExp(`[${IntLocalFormat.THOUSAND_SEPARATOR}]`, 'g'), '')
  }

  _numberToLocalString (number) {
    return new Intl.NumberFormat(navigator.language).format(number)
  }
}

export default IntLocalFormat
